import { ToastContainer } from 'modules/toast/ToastContainer';
import { FC, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useApplicationCount } from 'shared/hooks/useApplicationCount';
import { useBasePathname } from 'shared/hooks/useBasePathname';
import { useTopbarHidden } from 'shared/hooks/useTopbarHidden';
import { mergeClasses } from 'shared/utils/mergeClasses';
import { Navbar } from './components/Navbar/Navbar';
import { Topbar } from './components/Topbar/Topbar';
import { useApplicationStatusRealtimer } from './hooks/useApplicationStatusRealtimer';
import { useExtractionNotifications } from './hooks/useExtractionNotifications';
import { useNotificationRealtimer } from './hooks/useNotificationRealtimer';

const whiteBackgroundOnMobilePathnames = ['/job-orders'];
const zeroPaddingPages = ['/', '/observed'];

export const LoggedLayout: FC = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const topbarHidden = useTopbarHidden();

  const staticPathname = useBasePathname();
  const { hasMobileWhiteBackground, hasPadding } = useMemo(
    () => ({
      hasMobileWhiteBackground: whiteBackgroundOnMobilePathnames.includes(staticPathname),
      hasPadding: !zeroPaddingPages.includes(staticPathname),
    }),
    [staticPathname],
  );

  useExtractionNotifications();
  useApplicationCount();
  useNotificationRealtimer();
  useApplicationStatusRealtimer();

  return (
    <>
      <ToastContainer topbarHidden={topbarHidden} />
      <main
        className={mergeClasses(
          `relative grid min-h-full-device w-full gap-4 lg:grid-cols-[101px_1fr]`,
          hasMobileWhiteBackground ? 'bg-white' : 'bg-lightBlue lg:bg-white',
        )}
      >
        <Navbar open={navbarOpen} onClose={() => setNavbarOpen(false)} />
        <div className="w-full lg:col-start-2">
          <Topbar topbarHidden={topbarHidden} onHamburgerClick={() => setNavbarOpen(true)} />
          <div
            className={mergeClasses(
              'mt-14 md:mt-16 lg:mt-17',
              hasPadding ? 'px-4 py-6 lg:px-6 lg:py-8' : '',
            )}
          >
            <Outlet />
          </div>
        </div>
      </main>
    </>
  );
};
